import { ENetworkEventBothWays } from './ENetworkEventBothWays';

export const ENUM__network_event_server_to_client = {
  ...{
    /*
     * ADMIN
     */

    ADMIN_USERS_ONLINE_UPSERT: '/admin/users/online/upsert',

    /*
     * APP INFO
     */

    APP_INFO_UPSERT: '/app_info/upsert',

    /*
     * COLLECTION
     */

    COLLECTION_UPSERT: '/collection/upsert',
    COLLECTION_DELETE: '/collection/delete',

    COLLECTION_SPECIAL_INFO_UPSERT: '/collection/images_ids_on_special_collections_upsert',

    /*
     * DIFFUSION MODELS UD
     */
    ML_ASSET_RESERVATION_DELETE: '/ml_asset_reservation/delete',
    ML_ASSET_RESERVATION_UPSERT: '/ml_asset_reservation/upsert',

    ML_ASSET_UPSERT: '/ml_asset/upsert',
    ML_ASSET_TABLE_UPSERT_WITHOUT_PAGES: '/ml_asset_table/upsert_without_pages',
    ML_ASSET_TABLE_PAGE_UPSERT: '/ml_asset_table_page/upsert',

    /*
     * GENERATION
     */

    GENERATION_NEXT_CREATED: `/generation/next/created`,

    GENERATIONS_UPSERT: `/generations/upsert`,

    GENERATION_FAILED: '/generation/failed',

    GENERATION_GRAPH_FIELDS_UPSERT: '/generation/graph/fields/upsert',

    /*
     * GENERATION PRICE
     */

    GENERATION_PRICE_UPSERT: '/generation_price/upsert',

    /*
     * GRID2D
     */

    GRID2D_UPSERT: '/grid2d/upsert',
    GRID2D_UPDATE_PARTIAL: '/grid2d/update_partial',

    GRID2D_CHUNK_UPSERT: '/grid2d/chunk/upsert',
    GRID2D_CHUNK_UPDATE_WITHOUT_CELLS: '/grid2d/chunk/update_without_cells',

    GRID2D_CELLS_UPSERT: '/grid2d/cells/upsert',
    GRID2D_CELLS_DELETE: '/grid2d/cells/delete',

    IMAGE_UPSERT: '/image/upsert',
    IMAGE_META_UPSERT: '/image/meta/upsert',

    /*
     * USER TASKS
     */
    USER_TASK_UPSERT: '/user_task/upsert',
    //we use user_task update instead upsert because user_task with generations is too heavy
    USER_TASK_UPDATE_WITHOUT_GENERATIONS: '/user_task/update_without_generations',
    USER_TASK_DELETE: '/user_task/delete/',

    /*
     * IMAGE DESCRIPTION
     */
    IMAGE_AI_DESCRIPTION_UPSERT: '/image_ai_description/upsert',

    /*
     * SEARCH
     */

    SEARCH_UPSERT: '/search/upsert',
    SEARCH_DELETE: '/search/delete',

    /*
     * USER SETTIGNS
     */
    USER_AUTH_FAILED: '/user/auth/failed',
    USER_SETTINGS_UPSERT: '/user/settings/upsert',
    USER_TUTORIAL_PROGRESS_UPSERT: '/user/tutorial_progress/upsert',

    /*
     * WORDS
     */

    WORDS_UPSERT: '/words/upsert',

    /*
     * WORDS WITH RELATED WORDS
     */

    WORDS_WITH_RELATED_WORDS_UPSERT: '/words_with_related_words/upsert',

    /*
     * WORKSPACE BILLING
     */

    WORKSPACE_BILLING_CREDITS_TRANSACTIONS_UPSERT: `/workspace/billing/credits_transactions/upsert`,
    WORKSPACE_BILLING_PAYMENT_TRANSACTIONS_UPSERT: `/workspace/billing/payment_transactions/upsert`,
    WORKSPACE_BILLING_BALANCE_UPSERT: `/workspace/billing/balance/upsert`,
    WORKSPACE_BILLING_LOW_BALANCE: `/workspace/billing/low_balance`,

    WORKSPACE_SUBSCRIPTIONS_UPSERT: `/workspace/subscriptions/upsert`,

    /*
     * WORKSPACE
     */

    WORKSPACE_ALL_DATA_LOADED: '/workspace/all_data_loaded',

    WORKSPACE_UPSERT: '/workspace/upsert',
    WORKSPACE_DELETE: '/workspace/delete',

    WORKSPACE_USER_UPSERT: '/workspace/user/upsert',
    WORKSPACE_USER_ACTION_UPSERT: '/workspace/user/action/upsert',
    WORKSPACE_USER_DELETE: '/workspace/user/delete',

    WORKSPACE_CHILD_ENTITY_VIEWER_UPSERT: '/workspace/child_entity/viewer/upsert',
    WORKSPACE_CHILD_ENTITY_VIEWER_DELETE: '/workspace/child_entity/viewer/delete',

    WORKSPACE_USER_INVITATION_UPSERT: '/workspace/user_invitation/upsert',
    WORKSPACE_USER_INVITATION_DELETE: '/workspace/user_invitation/delete',

    WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_UPSERT: '/workspace/transfer_ownership_proposal/upsert',
    WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_DELETE: '/workspace/transfer_ownership_proposal/delete',
  },
  ...ENetworkEventBothWays,
};
